import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class DeleteMercadopagoVendorCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IDeleteMercadopagoVendorParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.DELETE;
  override _commandUrl = 'vendor/mercadopago/{userId}/{appId}';
  public override setParameters(parameters: IDeleteMercadopagoVendorParameters) {
    this._commandUrl = this._commandUrl
      .replace('{userId}', parameters.userId.toString())
      .replace('{appId}', parameters.appId.toString());
  }
}

export interface IDeleteMercadopagoVendorParameters extends ICommandParameters {
  userId: string;
  appId: number;
}
